import React from 'react'
import style from "./LevelThreeDemandNoteFeild.module.css";

const LevelThreeDemandNoteFeild = () => {
  return (
    <div>
            <div className={style.bodyBox}>
          <div className={style.logoUploadContainer}>
      <div className={style.uploadsection}>
        <div className="appIdForm">
          <p className={style.bodyTitleNormal}>Demand Note Fields</p>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Applicant Name</label>
              <input
              
              className={style.InputTxtNum}
               type="text"  />
            </div>

            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Layout Name</label>
              <input
                className={style.InputTxtNum}               
                type="text"
              />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Mauza </label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Khasara No</label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Plot Area[sq.mt.] </label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Built -up area [sq.mt.] </label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Plot No. </label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Due Date</label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Particular 1 Rate in INR </label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Particular 1 Total Amount</label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Particular 2 Rate in INR </label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Particular 2 Total Amount</label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Scrutiny Charges</label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Total Demand Note Amount</label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Municipal Council Name<span className="text-red-500">{' *'}</span></label>
              <input 
              
              className={style.InputTxtNum}
              type="text"  />
            </div>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Office Address: Tehsil<span className="text-red-500">{' *'}</span></label>
              
              <input className={style.InputTxtNum} type="text"  />
            </div>
          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Office Address: District<span className="text-red-500">{' *'}</span></label>
              <input 
              
              className={style.InputTxtNumSingle}
              type="text"  />
            </div>

          </div>

          <div className={style.formRow}>
            <div className={style.formGroup}>
              <label className={style.subHeadingLabel}>Conditions for Demand Note </label>
              <textarea  className={style.textDemandNote}></textarea>

              {/* <input 
              
              className={style.InputTxtNumSingle}
              type="text"  /> */}
            </div>

          </div>

          {/* Button section for publish and close buttons */}
          <div className={style.buttonSection}>
            <button className={style.publishButton} >
              Save
            </button>
            <button className={style.publishButton}>Next & Preview</button>
          </div>
        </div>
      </div>
    </div>
    </div>

    </div>
  )
}

export default LevelThreeDemandNoteFeild
